// src/hooks/useNotification.js
import { useCallback, useState } from "react";

function useNotification() {
  const [notification, setNotification] = useState({
    show: false,
    message: "",
    type: "success"
  });

  const showNotification = useCallback((message, type = "success") => {
    setNotification({ show: false, message, type });
    setTimeout(() => {
      setNotification({ show: true, message, type });
    }, 0);
  }, []);

  const hideNotification = useCallback(() => {
    setNotification((prev) => ({ ...prev, show: false }));
  }, []);

  return { notification, showNotification, hideNotification };
}

export default useNotification;
